<template>
  <PostEditorContainer :fetch-post-loading="fetchPostLoading">
    <template v-slot:contentField>
      <PostBasicField />
      <PostContentField v-if="mode == 'edit' || mode == 'inspection'" />
      <PreviewPostContentField v-if="mode == 'readonly'" />
    </template>

    <template v-slot:rightToolBar>
      <template v-if="toolBarStatus == 'edit'">
        <WriterPostController />
        <ProofreadBtn />
        <OrderRegulationCheckField />
        <OrderController />
        <InspectionPreview v-if="post.id != null" />
        <TagField />
      </template>
      <template v-if="toolBarStatus == 'comment'">
        <CommentPostController />
        <CommentField />
      </template>
    </template>
  </PostEditorContainer>
</template>

<script>
import PostEditorContainer from '@/components/postEditor/layout/PostEditorContainer'
import PostBasicField from '@/components/postEditor/layout/PostBasicField'
import WriterPostController from './parts/WriterPostController'
import InspectionPreview from '@/components/postEditor/parts/InspectionPreview'
import OrderController from '@/components/postEditor/parts/OrderController'
import PostContentField from '@/components/postEditor/layout/PostContentField'
import PreviewPostContentField from '@/components/postEditor/layout/PreviewPostContentField'
import TagField from '@/components/postEditor/parts/TagField'
import OrderRegulationCheckField from '@/components/postEditor/parts/OrderRegulationCheckField'
import CommentField from '@/components/postEditor/parts/comments/CommentField'
import CommentPostController from '@/components/postEditor/parts/comments/PostController'
import headUtilsMixin from '@/mixins/head_utils'
import { mapState } from 'vuex'
import ProofreadBtn from '@/components/postEditor/parts/ProofreadBtn'

export default {
  components: {
    ProofreadBtn,
    PostEditorContainer,
    PostBasicField,
    PostContentField,
    PreviewPostContentField,
    WriterPostController,
    OrderController,
    InspectionPreview,
    TagField,
    OrderRegulationCheckField,
    CommentField,
    CommentPostController
  },
  mixins: [headUtilsMixin],
  data: () => {
    return {
      pageTitle: '記事編集',
      fetchPostLoading: false
    }
  },
  computed: {
    ...mapState({
      post: (state) => state.PostEditor.post,
      mode: (state) => state.PostEditor.mode,
      toolBarStatus: (state) => state.PostEditor.toolBarStatus
    })
  },
  mounted: async function () {
    this.fetchPostLoading = true
    const query = {
      postId: location.pathname
        .match(/\/posts\/\d*/)[0]
        .replace(/\/posts\//, '')
    }
    try {
      await this.$store.dispatch('PostEditor/fetchPost', query)
    } finally {
      this.fetchPostLoading = false
    }
  }
}
</script>
